/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Downshift from 'downshift';
import { Input as InputBase, InputWrapper, RightIconButton, } from '../input';
import { Dropdown, DropdownItem } from './Dropdown';
import { withContext, Context } from './context';
import { SelectButton, SelectButtonText } from './styled';
import { CloseIcon } from './icon/CloseIcon';
import { render, Box } from '@vital-ui/react-utils';
var Input = React.forwardRef(function (props, ref) { return (React.createElement(InputWrapper, null,
    React.createElement(InputBase, __assign({ ref: ref }, props, { pr: props.value && '2.2rem' })),
    props.value &&
        render(props.icon || CloseIcon, RightIconButton, {
            onClick: props.onRightButtonClick,
        }))); });
var Button = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, children = _a.children, props = __rest(_a, ["text", "children"]);
    return (React.createElement(Context.Consumer, null, function (_a) {
        var getToggleButtonProps = _a.getToggleButtonProps;
        return (React.createElement(SelectButton, __assign({}, props, getToggleButtonProps()),
            React.createElement(SelectButtonText, null, text),
            children));
    }));
};
Button.defaultProps = {
    text: undefined,
    children: null,
};
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select.prototype.render = function () {
        var _a = this.props, children = _a.children, rootProps = _a.rootProps, props = __rest(_a, ["children", "rootProps"]);
        return (React.createElement(Downshift, __assign({}, props), function (options) { return (React.createElement(Box, __assign({}, options.getRootProps(), rootProps),
            React.createElement(Context.Provider
            // @ts-ignore
            , { 
                // @ts-ignore
                value: __assign({}, props, options) }, children))); }));
    };
    Select.Input = withContext(Input, function (_a) {
        var getInputProps = _a.getInputProps, clearSelection = _a.clearSelection;
        return (__assign({}, getInputProps(), { onRightIconClick: clearSelection }));
    });
    Select.Dropdown = Dropdown;
    Select.DropdownItem = DropdownItem;
    Select.Context = Context;
    Select.Button = Button;
    return Select;
}(React.Component));
export { Select };
//# sourceMappingURL=Select.js.map